import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { find, chain, head, filter, isUndefined, size } from 'lodash';
import { Jumbotron } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';

import {
  connect as allConnect,
  actions as allActions
} from '../../reducers/index';
import './styles.css';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import LocalStorage from '../../components/LocalStorage/index';
import { url } from '../../constants/routes';
import MainLogo from './img/IAR_logo.svg';

class WelcomePage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.changeRole = this.changeRole.bind(this);
    this.changeCampus = this.changeCampus.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
		role: LocalStorage.getRole(),
		campus: LocalStorage.getCampus(),
		isLoggedIn: LocalStorage.getLogin(),
		showPromo: this.isShowPromo(),
    };
  }

  isShowPromo(){

	const estOptions = {
		timeZone: 'America/New_York',
		year: 'numeric',
		month: 'numeric',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
	};

	// Promo should only be visible from May 1 12AM to May 31 11:59PM
	let startDateTimeEST 		= new Date(new Date('2025-05-01T00:00:00').toLocaleString('en-US', estOptions));
	let endDateTimeEST 		= new Date(new Date('2025-06-01T00:00:00').toLocaleString('en-US', estOptions));


	// The following code will run only on test environment
	if(window.location.origin.includes("iar-dev")){
		// Change the start dates on dev for testing
		startDateTimeEST 	= new Date(new Date('2023-04-30T00:00:00').toLocaleString('en-US', estOptions));
	}

	const now = new Date(new Date().toLocaleString('en-US', estOptions));
	const isPromoTime = (now >= startDateTimeEST && now <= endDateTimeEST);
	return isPromoTime && LocalStorage.getCampus() === "UTSG" && LocalStorage.getRole() === "STUDENT";	
  }

  changeRole(event) {
    LocalStorage.setRole(event.target.value, 30);
    LocalStorage.setLogin(event.target.value, 30);
    this.setState({
      role: LocalStorage.getRole(),
      isLoggedIn: LocalStorage.getLogin(),
	  showPromo: this.isShowPromo()
    });
    this.props.onChangeRole(event.target.value);
    // window.location.reload();
  }

  changeCampus(event) {
    LocalStorage.setCampus(event.target.value, 30);
    // LocalStorage.setLogin(event.target.value, 30);
    this.setState({
      campus: LocalStorage.getCampus(),
      // isLoggedIn: LocalStorage.getLogin()
	  showPromo: this.isShowPromo()
    });
    this.props.onChangeCampus(event.target.value);
    // window.location.reload();
  }

  handleSubmit(event) {
    event.preventDefault();

    const { cache } = this.props;
    const instanceUUID =
      find(cache.instances, instance => !isUndefined(instance.instanceUUID))
        .instanceUUID || '';

    // const method = 'put';
    // const instanceUUID = '67C1F158-A43F-408E-AA29-67057AE90F0A';
    const displaySetId = 'pre-and-post-questionnaire';
    const surveyUUID = '427DC388-F520-457A-A070-89793C362B8D';
    // const instanceLinks = this.props.cache.instanceLinks;
    // const currentDisplaySetIds = map(instanceLinks, 'displaySetId');
    const instanceLinksDataToCreate = [
      {
        displaySetId,
        instanceUUID,
        surveyUUID
      }
    ];
    const instanceLinksToCreate = chain(instanceLinksDataToCreate)
      .reduce((accInstanceLinks, currInstanceLink) => {
        // const { displaySetId } = currInstanceLink;
        // const instanceLinkWithDisplaySetIdExists = filter(
        //   currentDisplaySetIds,
        //   currentDisplaySetId => currentDisplaySetId === displaySetId
        // );

        // if (isEmpty(instanceLinkWithDisplaySetIdExists)) {
        return accInstanceLinks.concat(currInstanceLink);
        // }

        // return accInstanceLinks;
      }, [])
      .value();

    // const instanceLinksToCreateSize = size(instanceLinksToCreate);

    this.props
      .onPostInstanceLinks({
        // requestProps: { instanceLinksToCreate, method }
        requestProps: { instanceLinksToCreate }
      })
      .then(fulfillProps => {
        if (fulfillProps.status === 200) {
          LocalStorage.setInstanceLinkUUID(fulfillProps.instanceLinks, 30);
          // this.context.router.history.push(url.HOME);
          this.props.history.push(url.MODULE);
          window.location.reload();
        }
      });
    // window.location.reload();
  }

  render() {
    const { role } = this.props;
    const handleClose = () => {
        this.setState({
          showPromo: false
        });
    }
    return (
      <div className="welcome-page">
        <Navigation role={role} />
        <div id="maincontent" className="container" role="main">
          <Jumbotron className="text-center">
            <img
              src={MainLogo}
              className="main-logo"
              alt="IAR Education Module Logo"
            />
            <p>
              Created to strengthen the University of Toronto's systems
              of support for student mental health and aligned with the{" "}
              <a href="https://mentalhealth.utoronto.ca/explore-our-care-model/" target="_blank">
                University of Toronto Student Mental Health Strategy
              </a>
                 {" "}and{" "}
              <a href="https://www.provost.utoronto.ca/planning-policy/student-mental-health/" target="_blank">
		Framework
              </a>
              {" "}and the{" "}
              <a href="https://mentalhealthcommission.ca/what-we-do/children-and-youth/studentstandard/" target="_blank">
	        National Standard of Canada for Mental-Health 
                and Well-Being for Post-Secondary Students.
              </a>
            </p>
            <h1 className="txt-purple">Welcome!</h1>
            <form className="user-type-form" onSubmit={this.handleSubmit}>
              <p>
                <label className="no-bold" htmlFor="user-type">
		    Learn to identify students in distress, hold assistive conversations, and make effective referrals to campus and community supports. To tailor this training, please select your campus and role from the dropdown menus.
                </label>
              </p>
		{
		/*this.state.campus === "UTSG" && this.state.role === "STUDENT" && 
		<div>This div is visible when this.state.campus is "UTSG"</div>*/
		}

  <Modal
    show={this.state.showPromo}
    onHide={handleClose}
    bsSize="lg"
    aria-labelledby="promo-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title id="promo-modal"><button className="btn-link" onClick={handleClose}>Close</button></Modal.Title>
    </Modal.Header>
    <Modal.Body className="text-center">
      <h1>
		IAR Giveaway! 
      </h1>
      <p className="larger no-bold">
		This month, we’re giving away three $50 gift cards for UTSG students who complete IAR training before May 31st! When you complete the training, after the feedback survey, you can submit your name and U of T email for a chance to win a gift card to Uber, Instacart or Amazon! 
		<br/>
		<br/>
		IAR Giveaway Rules: <a target="_blank" href="https://studentlife.utoronto.ca/identify-assist-refer-giveaway/">https://studentlife.utoronto.ca/identify-assist-refer-giveaway/</a>
      </p>
    </Modal.Body>
    <Modal.Footer />
  </Modal>
		
              <select
                id="user-type"
                value={this.state.campus}
                onChange={this.changeCampus}
                style={{ marginRight: 20 }}
              >
                <option aria-label="NONE" value="NONE">
                  - Select CAMPUS -{' '}
                </option>
                <option aria-label="UTSG" value="UTSG">
                  University of Toronto (St. George)
                </option>
                <option aria-label="UTSC" value="UTSC">
                  University of Toronto (Scarborough)
                </option>
                <option aria-label="UTM" value="UTM">
                  University of Toronto (Mississauga)
                </option>
                <option aria-label="OTHER" value="OTHER">
                  Other
                </option>
              </select>
              <select
                id="user-type"
                value={this.state.role}
                onChange={this.changeRole}
              >
                <option
                  style={{ textAlign: 'center' }}
                  aria-label="NONE"
                  value="NONE"
                >
                  - Select ROLE -{' '}
                </option>
                <option aria-label="FACULTY" value="FACULTY">
                  Faculty Member
                </option>
                <option aria-label="STAFF" value="STAFF">
                  Staff Member
                </option>
                <option aria-label="STUDENT" value="STUDENT">
                  Student
                </option>
                <option aria-label="OTHER" value="OTHER">
                  Other
                </option>
              </select>
	      <p>
		This training will take approximately 30 minutes to complete and includes interactive activities and assessment surveys. It is recommended to allocate 30 minutes for completion to avoid survey resets.
	      </p>
              <p>
                <input
                  disabled={this.state.role === 'NONE' || this.state.campus === 'NONE'}
                  className="btn btn-purple"
                  type="submit"
                  value="Submit"
                />
              </p>
            </form>
          </Jumbotron>
        </div>
        <Footer />
      </div>
    );
  }
}

WelcomePage.propTypes = {
  onChangeRole: PropTypes.func.isRequired,
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

WelcomePage.defaultProps = {
  role: {}
};

WelcomePage.contextTypes = {
  router: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  responses: state.cache.responses,
  cache: state.cache
});
// const Welcome = connect.role(WelcomePage);
const Welcome = connect(
  mapStateToProps,
  allActions
)(WelcomePage);

export default allConnect.role(Welcome);



// WEBPACK FOOTER //
// ./src/containers/Welcome/index.jsx